import { render, staticRenderFns } from "./PlanTrip.vue?vue&type=template&id=4046a4f6&scoped=true&lang=pug&"
import script from "./PlanTrip.vue?vue&type=script&lang=js&"
export * from "./PlanTrip.vue?vue&type=script&lang=js&"
import style0 from "./PlanTrip.vue?vue&type=style&index=0&id=4046a4f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4046a4f6",
  null
  
)

export default component.exports